module.exports = __webpack_public_path__ + "PEUGEOT-logo.png";